module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074dd_logo_200x200.c8ed5940.png";